import clsx from 'clsx';
import type * as React from 'react';

import type { BlockDiffData } from '@gitbook/doc-core';
import type { BlockProps } from '@gitbook/slate-react';
import { Tooltip } from '@gitbook/spine-react';

import { capitalizeFirstLetter } from '../../../utils';
import { BlockLayout } from '../BlockLayout';
import { useBlockLayout, useDiffBlockLayout } from '../common';
import { EditorWidthLayout } from '../contexts';
import { BlockDiffIcon } from './BlockDiffIcon';
import { BlockDiffLine } from './BlockDiffLine';

function getLabel(type: BlockDiffData['type']): string {
    return capitalizeFirstLetter(type).replace('_', ' ');
}

/*
 * Renderer for a diff block.
 */
export function BlockDiff(props: BlockProps): React.ReactElement {
    const { ancestors, node, children, attributes } = props;
    const data = node.data.toFrozenObject() as BlockDiffData;

    const layout = useBlockLayout({
        ancestors,
        node,
    });

    const diffLayout = useDiffBlockLayout({
        ancestors,
        node,
    });

    return (
        <BlockLayout renderMode={layout.renderMode}>
            <EditorWidthLayout.View>
                <div className="relative" {...attributes}>
                    {diffLayout ? (
                        <BlockDiffLine diff={data.type} {...diffLayout.line}>
                            <Tooltip label={getLabel(data.type)} position="right">
                                <div
                                    className={clsx(
                                        'absolute font-bold',
                                        diffLayout.icon.className
                                    )}
                                >
                                    <BlockDiffIcon diff={data.type} />
                                </div>
                            </Tooltip>
                        </BlockDiffLine>
                    ) : null}
                    {children}
                </div>
            </EditorWidthLayout.View>
        </BlockLayout>
    );
}
